// extracted by mini-css-extract-plugin
export default {"containerStatist":"Statistic_containerStatist__AfRuT","statText":"Statistic_statText__LY99-","valueOfStat":"Statistic_valueOfStat__eCWkG"};